import React from 'react'
import Thrillingone from './Thrilling/Thrillingone'
import ThrillingTwo from './Thrilling/ThrillingTwo';
import ThrillingThree from './Thrilling/ThrillingThree';
import ThrillingFour from './Thrilling/ThrillingFour';
import { Box, Typography } from "@mui/material";

import Navbar from '../components/Navbar'

function Thrilling() {
    return (
        <>
            <Navbar />
            <Box>
                <Thrillingone />
                <ThrillingTwo />
                <ThrillingThree />
                <ThrillingFour />



            </Box>
        </>
    )
}

export default Thrilling